import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import ItemsSelectFieldStandalone from "../forms/stand-alone-select-field";
import { useFormikContext } from "formik";
import AddButton from "../buttons/button";
import CloseIcon from "../../assets/icons/close-icon";
import { useDispatch } from "react-redux";
import LoadingOverlay from "../helper-components/overlay-loading";
import { invoiceProdDetailsAction } from "../../redux/actions/invoices-action";

export default function ProDetRightSlidePanel({ open, setOpen, selectedItem }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { values } = useFormikContext();
  const [productDetails, setProductDetails] = useState({
    item_id: selectedItem?.itemid,
    item_batch_number: selectedItem?.item_batch_number,
  });

  console.log(selectedItem, "dsfsdfdsfdsfsdfsf");

  useEffect(() => {
    setProductDetails((prev) => ({
      ...prev,
      item_id: selectedItem?.itemid ?? "",
      item_batch_number: selectedItem?.item_batch_number ?? "",
    }));
  }, [selectedItem]);

  const productList = Array.isArray(values?.data)
    ? values.data.map((item) => ({
        label: item?.item_name ?? "",
        value: item?.item_id ?? "",
        item_batch_number: item?.item_batch_number ?? "",
      }))
    : [];

  console.log(productDetails, "dsfsdfdsfdsfsdfsf");

  useEffect(() => {
    if (selectedItem?.itemid && open) {
      console.log(productDetails, "dsfsdfdsfdsfsdfsf");

      dispatch(
        invoiceProdDetailsAction(
          {
            item_id: productDetails.item_id,
            item_batch_number: productDetails?.item_batch_number,
          },
          onSuccess,
          onError
        )
      );
    }
  }, [productDetails.item_id, open]);

  const onSuccess = (data) => {
    console.log(data, "dsfsdfdsfdsfsdfsf");
    setLoading(false);
    setProductDetails({ ...productDetails, ...data?.data });
  };

  const onError = () => {
    setLoading(false);
  };

  const InfoRow = ({ label, value, className = "" }) => (
    <div className={`flex flex-col gap-1 ${className}`}>
      <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
        {label}
      </div>
      <div className="text-[var(--slide-panel-value)] text-[length:var(--slide-panel-value-fs)] font-[var(--slide-panel-value-fw)] text-wrap">
        {value || "-"}
      </div>
    </div>
  );

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => {
          setOpen(false);
        }}
      >
        <div className="fixed inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-[#0000004D]" />
          </Transition.Child>

          <div className="fixed inset-0 flex justify-end">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-300"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-300"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <Dialog.Panel className="h-full w-[400px] sm:w-[700px] bg-white overflow-y-auto rounded-tl-lg rounded-bl-lg shadow-xl">
                {/* Header */}
                <div
                  className="h-[61px] bg-[var(--slide-panel-head-bg)] px-3 flex items-center justify-between border-b"
                  style={{ borderColor: "var(--slide-panel-border)" }}
                >
                  <div className="min-w-[75%]">
                    <ItemsSelectFieldStandalone
                    fieldClass="w-[70%]"
                      name="uom"
                      label="Product Details"
                      isLabelReq
                      value={productDetails.item_id}
                      onChange={(sel) => {
                        setProductDetails((prev) => ({
                          ...prev,
                          item_id: sel?.value,
                          item_batch_number: sel?.item_batch_number,
                        }));
                      }}
                      options={productList}
                    />
                  </div>
                  <AddButton
                    onclkFn={() => {
                      setOpen(false);
                    }}
                    icon={
                      <CloseIcon
                        width="12px"
                        height="12px"
                        fill="var(--close-button-fg)"
                      />        
                    }
                    text={
                      <span className="flex items-center gap-1">
                        Close <span className="opacity-50">(X)</span>{" "}
                      </span>
                    }
                    className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                  />
                </div>

                {/* Product Detail Panel */}
                <div
                  style={{
                    maxHeight: `calc(100% - 61px)`,
                    minHeight: `calc(100% - 61px)`,
                  }}
                  className="p-4 overflow-y-auto"
                >
                  <div className="space-y-5 border border-[var(--slide-panel-border)] border-radius p-4">
                    <div className="flex ">
                      <div className="border-b border-b-[var(--slide-panel-border)]  space-y-5 py-3 w-[50%]">
                        <InfoRow
                          label="Company"
                          value={productDetails?.item_manufacturer}
                        />
                        <InfoRow label="UOM" value={productDetails?.item_uom} />
                      </div>
                      <div className="border-b border-b-[var(--slide-panel-border)]  space-y-5 py-3 w-[50%]">
                        <InfoRow
                          label="Rack No"
                          value={productDetails?.to_bin_location}
                        />
                      </div>
                    </div>

                    <div className="border-b border-b-[var(--slide-panel-border)] flex">
                      <div className=" flex flex-col gap-5 py-3 w-[50%]">
                        <InfoRow
                          label="Supplied By"
                          value={productDetails?.item_manufacturer}
                        />

                        <InfoRow
                          label="Cost Price"
                          value={productDetails?.cost_price}
                        />
                        <InfoRow
                          label="Purchased"
                          value={
                            productDetails?.purchased_days_ago ||
                            0 + " days ago"
                          }
                        />

                        <InfoRow
                          label="Cost Price GST"
                          value={productDetails?.cost_price_gst}
                        />
                      </div>
                      <div className=" flex flex-col gap-5 w-[50%] py-3">
                        <InfoRow
                          label="Purchase Price"
                          value={productDetails?.item_batch_final_purchase_rate}
                        />
                        <InfoRow
                          label="Act. Cost Price"
                          value={productDetails?.item_base_price}
                        />
                        <InfoRow
                          label="Purchase Scheme"
                          value={productDetails?.purchase_scheme}
                        />
                        <InfoRow
                          label="ACP GST"
                          value={productDetails?.acp_gst}
                        />
                      </div>
                    </div>

                    <div className="flex">
                      <div className="space-y-5 w-[50%] py-3">
                        <InfoRow
                          label="GST"
                          value={
                            productDetails?.item_batch_tax_percentage ?? 0 + "%"
                          }
                        />
                        <InfoRow
                          label="Sale Scheme"
                          value={productDetails?.sale_scheme}
                        />
                        <InfoRow
                          label="Act. Margin %"
                          value={productDetails?.actual_margin}
                        />
                      </div>
                      <div className=" space-y-5 w-[50%] py-3">
                        <InfoRow
                          label="MRP"
                          value={productDetails?.item_mrp_price}
                        />

                        <InfoRow
                          label="Selling Price"
                          value={productDetails?.item_selling_price}
                        />

                        <div className="flex flex-col gap-1">
                          <div className="text-[var(--slide-panel-label)]">
                            Margin %
                          </div>
                          <div
                            className="px-2 py-0.5 border-radius w-fit text-xs border text-[var(--success-color)] border-[var(--success-color)]"
                            style={{
                              backgroundColor:
                                "color-mix(in srgb, var(--success-color) 15%, transparent)",
                            }}
                          >
                            {productDetails?.item_batch_margin_percentage ?? 0}%
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <LoadingOverlay isLoading={loading} />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
